import React from "react";
import EbDialog from "../../../ExecutionBlueprint/ExecutionBlueprintLiveReview/_shared/EbDialog";

// The confirmation in front of Regenerate (handoff 34 §3). The coach isn't
// emailed again.
const BriefRegenerateDialog = ({ busy, onConfirm, onClose }) => (
  <EbDialog
    isOpen
    size="sm"
    tone="primary"
    icon={<i className="fa-solid fa-rotate-right" aria-hidden="true" />}
    title="Regenerate the brief?"
    subtitle="The current one will be replaced."
    busy={busy}
    onClose={onClose}
    actions={[
      { label: "Cancel", variant: "ghost", onClick: onClose },
      {
        label: "Regenerate",
        loadingLabel: "Regenerating…",
        variant: "primary",
        loading: busy,
        onClick: onConfirm,
      },
    ]}
  />
);

export default BriefRegenerateDialog;
